import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';
import { Ladder } from '../../../models/ladder.model';

@Component({
  selector: 'admin-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['impersonate.component.scss']
})
export class AdminImpersonateComponent implements OnInit {
  public busy: boolean = false;
  public players: Player[] = [];
  public ladders: Ladder[] = [];
  public ladderId: string;

  constructor(private authorizeService: AuthorizeService,
    private userSvc: UserService, private http: HttpClient,
    private routerLink: Router) {
    this.busy = false;
  }

  ngOnInit(): void {
    this.queryPlayers(null);
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders = resp.map(l => new Ladder(l));
        this.ladders.unshift(new Ladder({ ladderId: null, name: 'Clear/Blank/Null' }))
      }
    );
  }

  private fetchPlayers(evt: any) {
    const x = this.ladderId;
    this.queryPlayers(this.ladderId);
  }

  private queryPlayers(ladderId: string) {
    let url = `/admin/getallplayers`;
    let options = {};
    if (ladderId != null && ladderId != 'null') {
      //url += `?ladderId=${ladderId}`;
      let params = new HttpParams()
        .set('ladderId', ladderId)
      options = { params: params }
    }
    this.http.get<Player[]>(url, options).subscribe(
      (resp: Player[]) => {
        console.log(resp);
        this.players.length = 0;
        for (let p of resp) {
          this.players.push(new Player(p));
        }
      }
    );
  }

  public impersonate(evt: any, id: string): void {
    var oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    document.cookie = `impersonate=${id}; expires=${oneYearFromNow.toDateString()}; path=/`;

    this.userSvc.clearCache();
    localStorage.removeItem('ladderId');
    localStorage.removeItem('levelId');
    this.routerLink.navigate(['/home']);
  }

  public clear(evt: any) {
    document.cookie = `impersonate=; path=/`;
    this.userSvc.clearCache();
    localStorage.removeItem('ladderId');
    localStorage.removeItem('levelId');
    this.routerLink.navigate(['/home']);
  }

}
